<template>
  <div class="layout-box">
    <div class="layout-header" :class="{'header-hidden':hiddenHead}">
      <div class="header_tag-box"><tags ref="tagRef"/></div>
      <div class="header_right-box">
        <div class="screen-out-box"><fullscreen v-model="isFullscreen" style="margin-right: 10px;"/></div>
        <Tooltip :content="langMap.hideNav[lang]">
          <div class="hidden-btn" @click="hiddenHead = true">
          <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="26">
          <path d="M348.5 287.5c52.7-18.9 108.4-28.4 164.5-28 165.5 0 300.7 74.2 405.6 222.4 12.5 17.7 12.6 41 0.2 58.7-45.4 65.1-97 115.8-154.7 152.3l69.3 67.7-37.6 36.7-547.2-534 37.6-36.6 62.3 60.8z m304.1 296.7c12.7-21.6 19.8-46.5 19.8-73 0-83.4-71.4-151.1-159.5-151.1-26.3 0-51 6-72.9 16.7l62.1 60.7c3.6-0.5 7.2-0.7 10.9-0.7 44.1 0 79.7 33.8 79.7 75.5 0 4.3-0.4 8.5-1.1 12.6l61 59.3zM250.7 337.7l116.1 113.2c-8.5 18.5-13.2 38.9-13.2 60.3 0 83.4 71.4 151 159.5 151 20.9 0 40.9-3.8 59.3-10.8l91 88.8c-48.5 15.4-99.3 23-150.3 22.7-166.9 0-302.1-74.1-405.7-222.3-12.4-17.7-12.3-41.1 0.2-58.8 42.5-60.2 90.3-108.3 143.1-144.1z m256.1 250c-39.8-3.1-71.3-33.7-73.3-71.6l73.3 71.6z" p-id="5873"></path>
          </svg>
          </div>
        </Tooltip>
        <div class="lang-out-box"><Language/></div>
        <switchSys @change="refreshTags"/>
        <user :user-avator="userAvator"/>
      </div>
    </div>
    <!--主体部分-->
    <div class="layout-body scrollbar-g">
      <router-view v-if="showRouter"/>
      <div v-else class="layout-loading">
        <Spin size="large"></Spin>
      </div>
    </div>
    <div class="down-arrow" v-show="hiddenHead">
      <!-- <svg class="icon" viewBox="0 0 1024 1024" width="30" height="30" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="959" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path d="M513.2 835.8c-6.6 0-13-2.6-17.7-7.3L109.8 443c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0l367.9 367.7 364.3-367.6c9.7-9.8 25.5-9.9 35.4-0.2 9.8 9.7 9.9 25.5 0.2 35.4L531 828.4c-4.7 4.7-11.1 7.4-17.8 7.4z" fill="#424242" p-id="960"></path>
        <path d="M513.2 621.2c-6.6 0-13-2.6-17.7-7.3L109.8 228.4c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0l367.9 367.7 364.3-367.6c9.7-9.8 25.5-9.9 35.4-0.2 9.8 9.7 9.9 25.5 0.2 35.4L531 613.8c-4.7 4.7-11.1 7.4-17.8 7.4z" fill="#424242" p-id="961"></path>
      </svg> -->
      <div class="arrow_content" @click="hiddenHead = false">
        <svg class="icon" viewBox="0 0 1079 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3228" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30">
          <path d="M 503.074 573.449 a 51.6864 51.6864 0 0 0 73.3184 0 l 369.707 -370.492 a 52.224 52.224 0 0 0 0 -73.6597 a 51.6693 51.6693 0 0 0 -73.3184 0 L 539.716 463.07 L 206.652 129.297 a 51.6693 51.6693 0 0 0 -73.3184 0 a 52.2667 52.2667 0 0 0 0 73.6597 l 369.741 370.492 Z m 369.707 -122.871 L 539.716 784.341 L 206.652 450.577 a 51.6693 51.6693 0 0 0 -73.3184 0 a 52.2496 52.2496 0 0 0 0 73.6427 l 369.732 370.492 a 51.7035 51.7035 0 0 0 73.3184 0 l 369.741 -370.492 a 52.2581 52.2581 0 0 0 0 -73.6427 a 51.7035 51.7035 0 0 0 -73.344 0 Z" fill="#8a8a8a" p-id="3229"></path>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import tags from './subunit/tags.vue';
import fullscreen from '../main/components/fullscreen';
import user from '../main/components/user';
import switchSys from '@/components/switchSys/index.vue';
import userFace from '@/assets/images/user-face.jpg';
import Language from '@/components/Language/index.vue';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { getToken } from '@/libs/util';

export default {
  components: { tags, fullscreen, user, switchSys,Language },
  data() {
    return {
      langMap:langMap,
      isFullscreen: false,
      hiddenHead: false,
      showArrow: false,
      // 用户信息就绪前不渲染子页面，避免读取到 undefined 的 userId
      showRouter: false
    }
  },
  methods: {
    refreshTags(path) {
      setTimeout(() => {
        this.$refs.tagRef && this.$refs.tagRef.initTags(path);
      }, 100);
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    userAvator() {
      return userFace;
    }
  },
  async created() {
    // 以当前 token 为唯一数据源确保用户信息就绪；
    // 新标签页/直接刷新时 sessionStorage 无 USER-INFO，会自动补拉一次
    const userInfo = await this.$store.dispatch('ensureUserInfo', this)
    if (userInfo && userInfo.userId) {
      this.showRouter = true
    } else if (getToken()) {
      // token 仍在但拿不到用户信息，视为会话数据异常，跳错误页
      // (token 已失效的情况下，api 层会统一跳登录页，这里不重复跳转)
      this.$router.push({ name: 'error_500' })
    }
  },
  mounted() {
    window.addEventListener('mousemove', (e) => {
      //console.log('fd--', hiddenHead);
      this.showArrow = this.hiddenHead && e.screenY < 200 ? true : false;
    });
  }
}
</script>
<style scoped lang="less">
.layout-box{
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;
  .layout-header{
    background-color: white;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 64px;
    align-items: center;
    transition: height 0.3s;
  }
  .header-hidden{
    height: 0;
    overflow: hidden;
  }
  .lang-out-box{
    height: 100%;
    display: flex;
    line-height: 64px;
    align-items: center;
  }
  .hidden-btn{
    margin-right: 15px;
    padding-top: 6px;
    cursor: pointer;
  }
  .header_tag-box{
    min-width: 60%;
    overflow-x: auto;
  }
  .screen-out-box{
    height: 100%;
    box-sizing: border-box;
    padding-top: 5px;
  }
  .header_right-box{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    padding-right: 50px;
  }
  .layout-body{
    flex:1;
    background-color: #F3F4F7;
    overflow: auto;
  }
  .layout-loading{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .down-arrow{
    position: fixed;
    width:100%;
    height: 150px;
    z-index: 10;
    pointer-events: none; // 点击穿透
    .arrow_content{
      top: 20px;
      left: 50%;
      position: absolute;
      opacity: 1;
      pointer-events: auto; // 点击穿透
      transform: translate(-50%,0);
      cursor: pointer;
    }
    // &:hover .arrow_content{
    //     opacity: 0;
    //     top: 20px;
    //   }
  }

}
@keyframes arrowShow {
  0%{
    opacity: 0;
  }
  100%{ opacity: 1; }
}

/* 允许内置浏览器和窄分屏按实际可用宽度排版，避免整页被 700px 下限横向裁切。 */
@media (max-width: 700px) {
  .layout-box {
    min-width: 0;

    .header_tag-box {
      flex: 1 1 auto;
      min-width: 0;
    }
    .header_right-box {
      flex-shrink: 0;
      padding-right: 12px;
    }
  }
}
</style>
